import { render, staticRenderFns } from "./ImageElementSettings.vue?vue&type=template&id=d408d336&scoped=true&"
import script from "./ImageElementSettings.vue?vue&type=script&lang=ts&"
export * from "./ImageElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d408d336",
  null
  
)

export default component.exports